// extracted by mini-css-extract-plugin
export default {"banner":"info-banner_banner__RVebg","iconContainer":"info-banner_iconContainer__M-xUx","content":"info-banner_content__2YX+I","text":"info-banner_text__DenSg"};